<template>
  <TableLayout v-permissions="['industry:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入行业名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="行业关键字" prop="keywords">
        <el-input v-model="searchForm.keywords" placeholder="请输入行业关键字" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['industry:create', 'industry:delete']">
        <li><el-button type="primary" @click="$refs.operaIndustryWindow.open('新建行业')" icon="el-icon-plus" v-permissions="['industry:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['industry:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="记录ID" min-width="100px"></el-table-column>
        <el-table-column prop="name" label="行业名称" min-width="100px"></el-table-column>
        <el-table-column prop="keywords" label="关键字" min-width="200px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="createUserInfo.realname" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
        <el-table-column prop="updateUserInfo.realname" label="修改人" min-width="100px"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" min-width="140px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['industry:update', 'industry:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaIndustryWindow.open('编辑行业', row)" icon="el-icon-edit" v-permissions="['industry:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['industry:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaIndustryWindow ref="operaIndustryWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaIndustryWindow from '@/components/industry/OperaIndustryWindow'
export default {
  name: 'IndustryList',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaIndustryWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        name: '',
        keywords: ''
      }
    }
  },
  methods: {
    /**
     * 页码变更处理（分页时触发）
     *
     * @param pageIndex 新页码
     */
    handlePageChange (pageIndex) {
      this.searchForm.keywords = this.searchForm.keywords.replace(/,/g, '')
      this.tableData.pagination.pageIndex = pageIndex || this.tableData.pagination.pageIndex
      this.isWorking.search = true
      this.api.fetchList({
        page: this.tableData.pagination.pageIndex,
        capacity: this.tableData.pagination.pageSize,
        model: this.searchForm,
        sorts: this.tableData.sorts
      })
        .then(data => {
          this.tableData.list = data.records
          this.tableData.pagination.total = data.total
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking.search = false
        })
    }
  },
  created () {
    this.config({
      module: '行业',
      api: '/industry/list',
      'field.id': 'id',
      'field.main': 'name'
    })
    this.search()
  }
}
</script>
